module.exports = __webpack_public_path__ + "static/media/6.f66f6934.jpeg";